import { isEmpty, forEach } from "ramda";

export default function updateArrangementsPriceWithoutDiscount() {
  const arrayArrangements = document.getElementsByClassName("to-calculate-price-without-discount");
  let arrangementsPrice = 0;

  if (!isEmpty(arrayArrangements ?? [])) {
    forEach((element) => {
      if (!isEmpty(element?.value ?? "")) {
        arrangementsPrice += parseFloat(element.value.replace(",", "."));
      }
    }, arrayArrangements);
  }

  return Number.parseFloat(arrangementsPrice);
}
